import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { BoatGroup } from '../boatList/BoatDetails';
import * as Icons from 'react-bootstrap-icons';
import { removeGroup, selectCurrentGroup } from '../boatList/boatListSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { GroupDetailsEdit } from './GroupDetailsEdit';
import { analyticsService } from '../../services/AnalyticsService';

export interface GroupDetailsCardProps {
  group: BoatGroup;
  currentGroup: boolean;
}

export function GroupDetailsCard(props: GroupDetailsCardProps) {
  const dispatch: AppDispatch = useDispatch();

  const [showEditor, setShowEditor] = useState(false);

  const handleClose = () => setShowEditor(false);
  const handleShow = () => setShowEditor(true);

  function editDetails() {
    console.log(`GroupDetailsCard.editDetails ${props.group.id}`);

    // Track group edit initiation
    analyticsService.logEvent('boat_management', {
      action_type: 'edit_group_opened',
      group_id: props.group.id,
      feature_name: 'group_details_card',
    });

    handleShow();
  }

  function deleteDetails() {
    console.log('GroupDetailsCard.deleteDetails');
    if (window.confirm(`Delete details for ${props.group.name}`)) {
      // Track group deletion
      analyticsService.logEvent('boat_management', {
        action_type: 'remove_group',
        group_id: props.group.id,
        feature_name: 'group_details_card',
        boat_count: props.group.boatDetails?.length || 0,
      });

      dispatch(removeGroup(props.group));
    } else {
      // Track deletion cancellation
      analyticsService.logEvent('boat_management', {
        action_type: 'remove_group_cancelled',
        group_id: props.group.id,
        feature_name: 'group_details_card',
      });
    }
  }

  function setCurrentGroup() {
    console.log('GroupDetailsCard.setCurrentGroup', props.group.id);

    // Track group selection
    analyticsService.logEvent('handicap_system_selection', {
      selected_system: props.group.handicapSystem,
      selection_method: 'group_selection',
      boat_count_affected: props.group.boatDetails?.length || 0,
      group_id: props.group.id,
    });

    dispatch(selectCurrentGroup(props.group.id));
  }

  return <>
    <GroupDetailsEdit
      show={showEditor}
      handleClose={handleClose}
      group={props.group} />
    <Card>
      <Card.Header>
        {props.group.name}
        <div className='float-end'>
          <Icons.Pencil onClick={editDetails} className='cursor-pointer' />
          &nbsp;
          <Icons.Trash onClick={deleteDetails} className='cursor-pointer' />
          &nbsp;
          {
            props.currentGroup ?
              <Icons.StarFill onClick={setCurrentGroup} className='cursor-pointer' /> :
              <Icons.Star onClick={setCurrentGroup} className='cursor-pointer' />
          }

        </div>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          Handicap System : {props.group.handicapSystem}
        </Card.Text>
      </Card.Body>
    </Card>
  </>;
}
